import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function Cash(props) {
  return (
    <Svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Circle cx="40" cy="40" r="40" fill="#FF7A00" fill-opacity="0.05" />
      <Path
        d="M40.1497 51.4351C35.9138 51.4351 31.6779 51.4351 27.442 51.4351C27.0185 51.4351 26.5797 51.4351 26.1713 51.3292C25.1274 51.0569 24.3559 50.4215 24.0987 49.3474C23.8264 48.2431 24.1138 47.2446 25.0064 46.4731C26.9731 44.7485 28.2287 42.6305 28.6826 40.0436C28.9397 38.5913 28.8641 37.1239 28.8641 35.6716C28.8641 33.8864 28.8036 32.1013 29.3331 30.3464C30.5736 26.1862 34.5523 22.8731 38.8638 22.4949C39.3933 22.4495 39.9228 22.4193 40.4523 22.4041C40.9969 22.3739 41.1936 22.4949 40.9515 23.1303C38.6218 29.0908 41.5869 35.6413 47.5928 37.8803C48.6366 38.2736 49.7259 38.5005 50.8302 38.5308C51.2538 38.5459 51.4354 38.6215 51.4807 39.1057C51.753 42.0708 53.0389 44.5215 55.2779 46.5185C56.2764 47.411 56.5487 48.5608 56.0797 49.6651C55.5653 50.8451 54.6123 51.4351 53.3264 51.4351C48.9241 51.4351 44.5369 51.4351 40.1497 51.4351Z"
        fill="#FF7A00"
        fill-opacity="0.8"
      />
      <Path
        d="M40.0743 53.0691C41.814 53.0691 43.5538 53.0993 45.2784 53.0539C45.9591 53.0388 46.0348 53.2657 45.8381 53.8557C44.6279 57.4562 40.1953 59.0296 36.9881 57.0175C35.6871 56.2006 34.8399 55.0811 34.3407 53.6591C34.1743 53.1901 34.2953 53.0539 34.7945 53.0539C36.5494 53.0842 38.3043 53.0691 40.0743 53.0691Z"
        fill="#FF7A00"
        fill-opacity="0.5"
      />
      <Circle cx="50.8002" cy="27.6" r="7.6" fill="#FF7A00" />
      <Path
        d="M50.9897 32.3402C49.8043 32.3402 48.927 31.8875 48.3577 30.9822C47.7977 30.0769 47.5177 28.8169 47.5177 27.2022C47.5177 26.1289 47.6297 25.2095 47.8537 24.4442C48.087 23.6695 48.4557 23.0769 48.9597 22.6662C49.473 22.2555 50.1497 22.0502 50.9897 22.0502C52.175 22.0502 53.0523 22.5029 53.6217 23.4082C54.2003 24.3135 54.4897 25.5782 54.4897 27.2022C54.4897 28.2755 54.373 29.1949 54.1397 29.9602C53.9157 30.7255 53.547 31.3135 53.0337 31.7242C52.5203 32.1349 51.839 32.3402 50.9897 32.3402ZM50.9897 30.4362C51.419 30.4362 51.713 30.1702 51.8717 29.6382C52.0397 29.0969 52.1237 28.2849 52.1237 27.2022C52.1237 26.1289 52.0397 25.3215 51.8717 24.7802C51.713 24.2389 51.419 23.9682 50.9897 23.9682C50.5697 23.9682 50.2757 24.2389 50.1077 24.7802C49.949 25.3215 49.8697 26.1289 49.8697 27.2022C49.8697 28.2755 49.949 29.0829 50.1077 29.6242C50.2757 30.1655 50.5697 30.4362 50.9897 30.4362Z"
        fill="white"
      />
    </Svg>
  );
}

export default Cash;
